/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { forwardRef, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

import Tooltip from "@material-ui/core/Tooltip";
import ChatIcon from "@material-ui/icons/Chat";

import blue from "@material-ui/core/colors/blue";
import grey from "@material-ui/core/colors/grey";

import types from "../../helpers/types";
import TooltipNote from "./TooltipNote";
import { getLatestNoteForSpotLeg } from "../../api/api";

let latestSpotLegNoteTokenSource;

const SpotNotesTooltipIcon = forwardRef(({ noteReadStatus, spotLegId, style, ...props }, ref) => {  
  const [latestSpotLegNote, setLatestSpotLegNote] = useState('');

  const fetchLatestSpotLegNote = async (spotLegId) => {
    setLatestSpotLegNote('');
    if (latestSpotLegNoteTokenSource) latestSpotLegNoteTokenSource.cancel();  
    latestSpotLegNoteTokenSource = axios.CancelToken.source();    
    const latestNote = await getLatestNoteForSpotLeg(spotLegId);
    if (latestNote) {
      setLatestSpotLegNote(<TooltipNote note={latestNote} />);
    }
  };

  return (
    <Tooltip
      arrow
      key={`latestnote-tooltip-${spotLegId}`}
      title={latestSpotLegNote}
      onOpen={() => {
        fetchLatestSpotLegNote(spotLegId);
      }}
    >
    <ChatIcon
      style={{
        color:
          noteReadStatus === types.noteReadStatus.unread
            ? blue[600]
            : grey[500],
        fontSize: "18px",
        ...style,
      }}
      {...props}
      ref={ref}
    />
  </Tooltip>
  );
});

export default SpotNotesTooltipIcon;
